import React, { useMemo } from 'react'
import Box from '@material-ui/core/Box'
import MuiTextField from '@material-ui/core/TextField'
import useT from '../../../i18ns/admin/useT'
import { useCommonStyles } from '../../../utils/admin/StyleHook'
import { AdminPlayerInfoLocation } from '@golden/gdk-admin'

interface PropTypes {
  id: number
  location: AdminPlayerInfoLocation
}

const TextField = React.memo(MuiTextField)

const PlayerNicknameInput: React.FC<PropTypes> = (props) => {
  const { location } = props
  const classes = useCommonStyles()
  const { t } = useT()
  const value = useMemo(() => `${(location?.register_ip_province || location?.register_ip_country) ?? 'X'}/${(location?.phone_province || location?.phone_country) ?? 'X'}/${(location?.debit_card_province || location?.debit_card_country) ?? 'X'}`, [location])

  return (
    <TextField
      label={<Box className={classes.nowrap}>
        {`${t('common.registerIP')}/${t('common.cellphoneShort')}/${t('common.debitCard')}`}
        {
          location?.location_not_match && (
            <Box component="span" marginLeft={1} className={classes.chipText} style={{ backgroundColor: '#ff5f5f' }}>
              {t('common.locationNotMatch')}
            </Box>
          )
        }
      </Box>}
      value={value}
      disabled
      fullWidth
    />
  )
}

export default React.memo(PlayerNicknameInput)
